import _ from 'lodash'
import store from '@/store'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
import moment from 'moment'
import momenttz from 'moment-timezone'

const Validator = SimpleVueValidator.Validator;

const mofaMixin = {
    validators: {
      // agencyName: function (value) {
      //   return Validator.custom(function () {
      //     if (Validator.isEmpty(value)) {
      //         return 'This is a required field.'
      //     }
      //     var found = _.find(store.state.agencyList, function (obj) {
      //                       return obj.name.toLowerCase() === value.toLowerCase();
      //                   });
      //     if (found) {
      //         return 'Agency name is already exists.'
      //     }
      //   })
      // },
      'mofa.start_date': function (value) {
        return Validator.custom(function () {
          if ( store.state.modified && Validator.isEmpty(value)) {
              return 'This is a required field.'
          }          
        })
      },
      'mofa.end_date': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.vehicle_type': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.no_vehicle' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.route' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.distribution_plan' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.initial_beneficiary' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.beneficiaries' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }
    }
  }

export default mofaMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/LandMofa-validators.js